<template>
  <div>
    <proa-heading>{{ $t('pages.notFound.heading') }}</proa-heading>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>
